import React from "react";
import { useLocalStore, useObserver, Observer } from "mobx-react";
import { Form } from "@modules/formx-react";
import { useLocale, useUserProfile } from "@hooks";
import { ErrorCard, Spinner } from "@components";
import { useNavigation } from "@navigation";
import { TabFormLayout } from "@components/forms/TabFormLayout";
import { CustomerContractPriceListFormStore } from "./CustomerContractPriceListFormStore";
import { CustomerContractPriceListFormContext } from "./CustomerContractPriceListFormContext";
import { PriceListMainForm } from "./PriceListMainForm/PriceListMainForm";
import { FormxDebugger } from "@common/formx";

export type CustomerContractPriceListEditorProps = {
  contractId: string;
  priceListId: string;
  isDuplicate?: boolean;
};

export function CustomerContractPriceListEditor(
  props: CustomerContractPriceListEditorProps
) {
  const nav = useNavigation();
  const { can } = useUserProfile();
  const formStore = useLocalStore(() => {
    return new CustomerContractPriceListFormStore(
      props.contractId,
      props.priceListId,
      props.isDuplicate,
      nav
    );
  });

  const { locale } = useLocale();

  return useObserver(() => {
    if (formStore.loading) {
      return <Spinner fullHeight />;
    }

    if (formStore.error) {
      console.log(formStore.error);
      return <ErrorCard title="error" message={formStore.error.toString()} />;
    }

    return (
      <CustomerContractPriceListFormContext.Provider value={formStore}>
        <Form store={formStore.form}>
          <FormxDebugger />

          <Observer>
            {() => (
              <TabFormLayout
                blockId={"customer_contract_price_list"}
                canSubmit={formStore.form.canSubmit}
                isDirty={formStore.form.dirty}
                isSubmitting={formStore.form.isSubmitting}
                hideButtons={!can("customer-contract:edit:all")}
                onSubmit={formStore.form.submit}
                onReset={formStore.form.reset}
                onClose={nav.close}
                tabs={[
                  {
                    label: locale.Prices,
                    value: "prices",
                    content: <PriceListMainForm />
                  }
                ]}
              />
            )}
          </Observer>
        </Form>
      </CustomerContractPriceListFormContext.Provider>
    );
  });
}
